import actions from '../../lib/api/actions';

export function blockInteraction({ commit }) {
  commit('blockInteraction');
}

export function allowInteraction({ commit }) {
  commit('allowInteraction');
}

export async function fetchVersion({ commit }) {
  const response = await actions.fetchVersion();
  if (response.status === 200) {
    commit('updateVersion', { version: response.data });
  }
}
